import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { Spinner } from './spinner';

const Loader = ({ className }: { className?: string }) => (
  <div className={cn('flex justify-center items-center content-center w-full h-screen', className)}>
    <div className="relative w-full max-w-[320px] h-1 bg-gray-400 dark:bg-gray-200 overflow-hidden">
      <motion.div
        className="relative top-0 h-full bg-blue-500"
        initial={{ x: '-100%' }}
        animate={{ x: ['-100%', '100%'] }}
        transition={{
          duration: 1,
          ease: 'linear',
          repeat: Infinity,
        }}
      />
    </div>
  </div>
);

interface ContentLoaderProps {
  show: boolean;
  title?: string;
}
const ContentLoader: React.FC<ContentLoaderProps> = ({ show = false, title = 'Carregando...' }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 flex flex-col justify-center items-center bg-black/40 backdrop-blur-sm z-90">
      <Spinner className="size-18" />
    </div>
  );
};

export { ContentLoader, Loader };
